export interface ShareProps extends ShareData {
  color?: ShareColor;
  className?: string;
  label?: string;
  headline?: string;
  asNavItem?: boolean;
}

export enum ShareColor {
  White = 'white',
  DarkGray = 'dark-gray',
  Black = 'black',
}
